export default class Menu {
    
    constructor()
    {
        if ( window.matchMedia( "(max-width: 1200px)" ).matches ) {
            Menu.burger();
        }
    }
    
    static burger()
    {
        const trigger           = '[data-trigger="wpiris-menu-toggle"]',
              $element          = $( '[data-id="wpiris-menu"]' ),
              elementItem       = '[data-id="wpiris-menu-item"], [data-id="wpiris-menu-item-submenu"]',
              elementItemParent = '[data-id="wpiris-menu-item"].withChildrens > a, [data-id="wpiris-menu-item-submenu"].withChildrens > a',
              triggerMore       = '[data-trigger="wpiris-menu-more"]',
              triggerBack       = '[data-trigger="wpiris-menu-back"]';
              
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.toggleClass( 'open' );
            $( trigger ).toggleClass( 'open' );
            $( 'body' ).toggleClass( 'menuOpen' );
            $( '.submenuActive' ).removeClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', triggerMore, function ( e ) {
            $( elementItem ).removeClass( 'submenuActive' );
            $( this ).parent().addClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', triggerBack, function ( e ) {
            $( this ).closest( elementItem ).removeClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', elementItemParent, function ( e ) {
            e.preventDefault();
            $( elementItem ).removeClass( 'submenuActive' );
            $( this ).parents( elementItem ).addClass( 'submenuActive' );
        } );
    }
}
